import {
  ResolvedChatMessage,
  ResolvedCreateProgramsToolCall,
  ResolvedUpdateBusinessPlanSectionToolCall,
  TOOL_CREATE_PROGRAMS,
  TOOL_UPDATE_BUSINESS_PLAN_SECTION,
} from '../../../growegy-ai/types';
import useAuth from '../../../auth/authContext';
import { ProgramCalendarEvent } from '../calendar/ProgramCalendarEvent';
import { UnscheduledViewType } from '../../containers/types';
import { ResolvedProgramDatesField, ResolvedProgramOwnerField } from '../../types';
import _ from 'lodash';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { DivButton } from '../../../commons/components/DivButton';
import { CopyIcon } from '../../../assets/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import React from 'react';

const CreateProgramsToolCall = (props: { resolvedToolCalls: ResolvedCreateProgramsToolCall[] }) => {
  const { resolvedToolCalls } = props;
  const {
    state: { user },
  } = useAuth();
  if (!user) return null;
  return (
    <>
      {resolvedToolCalls
        .flatMap((x) => x.arguments.programs)
        .map((x, index) => {
          return (
            <div className="program-calendar__program-underlayer" key={`create_program_${index}`}>
              <ProgramCalendarEvent
                program={x}
                user={user}
                onClick={null}
                showCampaigns={false}
                applicableVisibleColumns={[ResolvedProgramDatesField, ResolvedProgramOwnerField]}
                viewType={UnscheduledViewType}
                shortcutFieldNamesOnly={false}
              />
            </div>
          );
        })}
      <div>Would you like to create the programs?</div>
    </>
  );
};

export const ToolCallMessageContent = (props: { message: ResolvedChatMessage }) => {
  const { message } = props;
  const {
    state: { user },
  } = useAuth();
  if (!user) return null;
  if (!message.resolvedToolCalls) return null;
  return (
    <div className="message-list__tool-calls-container">
      {_(message.resolvedToolCalls)
        .groupBy((x) => x.name)
        .map((toolCalls, name) => {
          switch (name) {
            case TOOL_CREATE_PROGRAMS:
              return (
                <CreateProgramsToolCall
                  key={name}
                  resolvedToolCalls={toolCalls as ResolvedCreateProgramsToolCall[]}
                />
              );
            case TOOL_UPDATE_BUSINESS_PLAN_SECTION:
              const sectionText = (toolCalls as ResolvedUpdateBusinessPlanSectionToolCall[])[0]
                .arguments.section_text;
              return (
                <div key={name} className="message-list__update-business-plan-container">
                  <div>Here is you business plan section:</div>
                  <div className="message-list__tool-call-quote">
                    <Markdown className="markdown-container" remarkPlugins={[remarkGfm]}>
                      {sectionText}
                    </Markdown>

                    <div className="d-flex justify-content-end align-items-center">
                      <CopyToClipboard text={sectionText}>
                        <DivButton icon={<CopyIcon />} />
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div>Would you like to use this text as business plan section content?</div>
                </div>
              );
            default:
              return null;
          }
        })
        .value()}
    </div>
  );
};
